'use client';

import { FC } from 'react';

import { useContentfulLiveUpdates } from '@contentful/live-preview/react';

import { BlockQuickLinkType } from '../../models/Content';
import { getBlockId } from '../../utils/content';
import { QuickLinkCards } from './QuickLinkCards';
import { transformBlockQuickLink } from './transformers';

type Props = {
    contentItem: BlockQuickLinkType;
};

export const BlockQuickLink: FC<Props> = ({ contentItem: initialContentItem }) => {
    const contentItem = useContentfulLiveUpdates(initialContentItem);
    const blockQuickLinkData = transformBlockQuickLink(contentItem);

    return (
        <QuickLinkCards
            id={getBlockId(contentItem)}
            blockTitle={blockQuickLinkData?.blockTitle}
            blockCta={blockQuickLinkData?.blockCta}
            cards={blockQuickLinkData?.cards}
            displayVariant={blockQuickLinkData?.displayVariant}
        />
    );
};
